import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import {toast} from 'react-toastify'
import recallsService from '../../../../../services/recalls.service'
import {set, useForm} from 'react-hook-form'

function RecallSettings() {
    const {clinicId} = useParams()

    const [settings,setSettings] = useState(null)
    const [editing,setEditting] = useState(false)
    useEffect(()=>{
        getSettings()
    },[])
    const getSettings = ()=>{
        recallsService.getClinicSettings(clinicId)
        .then(res=>{
            setSettings(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }

    const handleUpdateSettings = (newSettings) =>{
         setSettings(newSettings)
    }
  return (
    <>
        {settings && <>
            <div className="d-flex justify-content-end">
                <button className="btn btn-sm btn-secondary" onClick={()=>setEditting(!editing)}>Edit</button>
            </div>
            {editing? <RecallEdit settings={settings} updateSettings = {handleUpdateSettings}/> : <RecallView settings={settings}/>}
        </>}
    </>
  )
}

const RecallView = ({settings})=>{
    return (<>
       <table className="table table-striped mt-2">
        <tbody>
            <tr>
                <td>Status:</td>
                <td>{settings.isActive === 1? "Active" : "Inactive"}</td>
            </tr>
            <tr>
                <td>Limit Per Day:</td>
                <td>{settings.limitPerDay}</td>
            </tr>
            <tr>
                <td>Second Recall:</td>
                <td>After {settings.secondRecall} days</td>
            </tr>
            <tr>
                <td>Second Recall Medium</td>
                <td>{settings.secondRecallMedium}</td>
            </tr>
            <tr>
                <td>Third Recall:</td>
                <td>{settings.thirdRecall === 0 ? "Not Set": "After "+settings.thirdRecall+ "days of second recall."}</td>
            </tr>
            <tr>
                <td>Third Recall Medium:</td>
                <td>{settings.thirdRecallMedium}</td>
            </tr>
            <tr>
                <td>Fourth Recall:</td>
                <td>{settings.fourthRecall === 0 ? "Not Set": "After "+settings.fourthRecall+ "days of second recall."}</td>
            </tr>
            <tr>
                <td>Fourth Recall Medium:</td>
                <td>{settings.fourthRecallMedium}</td>
            </tr>

        </tbody>
       </table>
    </>)
}
const RecallEdit = ({settings,updateSettings})=>{
    const {register,handleSubmit,formState:{errors},} = useForm({
        defaultValues:{
            id:settings.id,
            clinicId:settings.clinicId,
            isActive:settings.isActive,
            limitPerDay:settings.limitPerDay,
            secondRecall:settings.secondRecall,
            secondRecallMedium:settings.secondRecallMedium,
            thirdRecall:settings.thirdRecall,
            thirdRecallMedium:settings.thirdRecallMedium,
            fourthRecall:settings.fourthRecall,
            fourthRecallMedium:settings.fourthRecallMedium,
        }
    })
    const [secondRecallMed,setSecondRecallMed] = useState(settings.secondRecallMedium)
    const [thirdRecallMed,setThirdRecallMed] = useState(settings.thirdRecallMedium)
    const [fourthRecallMed,setFourthRecallMed] = useState(settings.fourthRecallMedium)
    const onSubmit = (data) =>{
            //console.log(data)
            let updateData = data 
            updateData.secondRecallMedium = secondRecallMed
            updateData.thirdRecallMedium = thirdRecallMed
            updateData.fourthRecallMedium = fourthRecallMed
            
            recallsService.saveSettings(data.clinicId,updateData)
            .then(res=>{
                toast.success("Settings Updated",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            })
            .catch(err=>{
                toast.error("Error while update. See Console",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            })

            updateSettings(updateData)

    }
    const handleUpdate = ()=>{

    }
    const handleSecondRecallChkChange = (option,isChecked)=>{
        let selectedOptions  = secondRecallMed.split(',')
        let updatedOptions;
        if (isChecked) {
          updatedOptions = [...selectedOptions, option];
        } else {
          updatedOptions = selectedOptions.filter((item) => item !== option);
        }
        const updatedOptionsString = updatedOptions.join(',')
        setSecondRecallMed(updatedOptionsString)
    }
    const handleThirdRecallChkChange = (option,isChecked)=>{
        let selectedOptions  = thirdRecallMed.split(',')
        let updatedOptions;
        if (isChecked) {
          updatedOptions = [...selectedOptions, option];
        } else {
          updatedOptions = selectedOptions.filter((item) => item !== option);
        }
        const updatedOptionsString = updatedOptions.join(',')
        setThirdRecallMed(updatedOptionsString)
    }
    const handleFourthRecallChkChange = (option,isChecked)=>{
        let selectedOptions  = fourthRecallMed.split(',')
        let updatedOptions;
        if (isChecked) {
          updatedOptions = [...selectedOptions, option];
        } else {
          updatedOptions = selectedOptions.filter((item) => item !== option);
        }
        const updatedOptionsString = updatedOptions.join(',')
        setFourthRecallMed(updatedOptionsString)
    }
    return (<>
        <form onSubmit={handleSubmit(onSubmit)}>
        <table className="table table-striped mt-2">
        <tbody>
            <tr>
                <td>Status:</td>
                <td><select {...register('isActive')} className='form-select'>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                    </select>
                </td>
            </tr>
            <tr>
                <td>Limit Per Day:</td>
                <td>
                    <input type="number" className="form-control mb-1" {...register('limitPerDay',{min:0,max:100})} />
                    {errors.limitPerDay && <span className="text-danger">Limit Per day is between 0 to 100.</span> }  
                    
                </td>
            </tr>
            <tr>
                <td>Second Recall:</td>
                <td>
                <select {...register('secondRecall')} className='form-select'>
                        <option value="0">Disabled</option>
                        <option value="15">After 15 Days</option>
                        <option value="30">After 30 Days</option>
                        <option value="45">After 45 Days</option>
                        <option value="60">After 60 Days</option>
                        <option value="75">After 75 Days</option>
                        <option value="90">After 90 Days</option>
                        <option value="105">After 105 Days</option>
                    </select>

                </td>
            </tr>
            <tr>
                <td>Second Recall Medium</td>
                <td>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkSecondRecallEmail"
                            name="chkSecondRecalEmail"
                            checked={secondRecallMed.includes("EMAIL")}
                            onChange={(e) => handleSecondRecallChkChange("EMAIL", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Email</label>
                    </div>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkSecondRecallSms"
                            name="chkSecondRecalSms"
                            checked={secondRecallMed.includes("SMS")}
                            onChange={(e) => handleSecondRecallChkChange("SMS", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Sms</label>
                    </div>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkSecondRecallCall"
                            name="chkSecondRecalCall"
                            checked={secondRecallMed.includes("CALL")}
                            onChange={(e) => handleSecondRecallChkChange("CALL", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Call</label>
                    </div>

                </td>
            </tr>
            <tr>
                <td>Third Recall:</td>
                <td>
                <select {...register('thirdRecall')} className='form-select'>
                        <option value="0">Disabled</option>
                        <option value="15">After 15 Days</option>
                        <option value="30">After 30 Days</option>
                        <option value="45">After 45 Days</option>
                        <option value="60">After 60 Days</option>
                        <option value="75">After 75 Days</option>
                        <option value="90">After 90 Days</option>
                        <option value="105">After 105 Days</option>
                    </select>

                </td>
            </tr>
            <tr>
                <td>Third Recall Medium</td>
                <td>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkThirdRecallEmail"
                            name="chkThirdRecalEmail"
                            checked={thirdRecallMed.includes("EMAIL")}
                            onChange={(e) => handleThirdRecallChkChange("EMAIL", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Email</label>
                    </div>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkThirdRecallSms"
                            name="chkThirdRecalSms"
                            checked={thirdRecallMed.includes("SMS")}
                            onChange={(e) => handleThirdRecallChkChange("SMS", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Sms</label>
                    </div>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkThirdRecallCall"
                            name="chkThirdRecalCall"
                            checked={thirdRecallMed.includes("CALL")}
                            onChange={(e) => handleThirdRecallChkChange("CALL", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Call</label>
                    </div>

                </td>
            </tr>
            <tr>
                <td>Fourth Recall:</td>
                <td>
                <select {...register('fourthRecall')} className='form-select'>
                        <option value="0">Disabled</option>
                        <option value="15">After 15 Days</option>
                        <option value="30">After 30 Days</option>
                        <option value="45">After 45 Days</option>
                        <option value="60">After 60 Days</option>
                        <option value="75">After 75 Days</option>
                        <option value="90">After 90 Days</option>
                        <option value="105">After 105 Days</option>
                    </select>

                </td>
            </tr>
            <tr>
                <td>Fourth Recall Medium</td>
                <td>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkFourthRecallEmail"
                            name="chkFourthRecalEmail"
                            checked={fourthRecallMed.includes("EMAIL")}
                            onChange={(e) => handleFourthRecallChkChange("EMAIL", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Email</label>
                    </div>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkFourthRecallSms"
                            name="chkFourthRecalSms"
                            checked={fourthRecallMed.includes("SMS")}
                            onChange={(e) => handleFourthRecallChkChange("SMS", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Sms</label>
                    </div>
                    <div className="form-check">
                        <input 
                            type="checkbox" 
                            id="chkFourthRecallCall"
                            name="chkFourthRecalCall"
                            checked={fourthRecallMed.includes("CALL")}
                            onChange={(e) => handleFourthRecallChkChange("CALL", e.target.checked)}
                            className="form-check-input" />
                        <label htmlFor="" className="form-check-label">Call</label>
                    </div>

                </td>
            </tr>
            <tr>
                <td></td>
                <td>
                    <button className="btn btn-sm btn-primary" type="submit">Update</button>

                </td>
            </tr>

        </tbody>
       </table>
        </form>
    </>)
}

export default RecallSettings